import { render, staticRenderFns } from "./globalLoading.vue?vue&type=template&id=8c170df8&scoped=true&"
import script from "./globalLoading.vue?vue&type=script&lang=js&"
export * from "./globalLoading.vue?vue&type=script&lang=js&"
import style0 from "./globalLoading.vue?vue&type=style&index=0&id=8c170df8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_6e5aa5d092232e034912f9a422cd0645/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c170df8",
  null
  
)

export default component.exports